import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { IconButton } from "../../components/IconButton";

interface OwnProps {
  fieldName: string;
  defaultValue: string;
  onSubmit: (fieldName: string, value: string) => Promise<boolean>;
  showEdit: boolean;
  type?: "text" | "select";
  selectOptions?: { label: string; value: string }[];
}

interface State {
  isEditing: boolean;
  value: string;
  displayValue: string;
}

class InlineEdit extends React.Component<OwnProps, State> {
  constructor(props: OwnProps) {
    super(props);

    this.state = {
      isEditing: false,
      value: props.defaultValue,
      displayValue: props.defaultValue,
    };
  }

  render() {
    return (
      <>
        {this.state.isEditing ? (
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              await this.props.onSubmit(this.props.fieldName, this.state.value);
              this.setState({
                isEditing: false,
                displayValue: this.state.value,
              });
            }}
          >
            <div
              className="d-flex flex-row align-items-center"
              style={{ gap: "8px" }}
            >
              {this.props.type === "select" ? (
                <select
                  value={this.state.value}
                  onChange={(e) => this.setState({ value: e.target.value })}
                >
                  {(this.props.selectOptions || []).map((x) => (
                    <option key={x.value} value={x.value}>
                      {x.label}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type="text"
                  value={this.state.value}
                  onChange={(e) => this.setState({ value: e.target.value })}
                />
              )}
              <IconButton
                type="submit"
                icon={
                  <FontAwesomeIcon
                    icon={solid("check")}
                    color={colors.textPrimary}
                  />
                }
              />
              <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  this.setState({
                    value: this.props.defaultValue,
                    isEditing: false,
                  });
                }}
                type="button"
                icon={
                  <FontAwesomeIcon
                    icon={solid("x")}
                    color={colors.textPrimary}
                  />
                }
              />
            </div>
          </form>
        ) : (
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "16px" }}
          >
            {this.props.showEdit && (
              <IconButton
                onClick={(e) => this.setState({ isEditing: true })}
                icon={
                  <FontAwesomeIcon
                    icon={solid("pen")}
                    color={colors.textPrimary}
                  />
                }
              />
            )}
            <StyledText
              color={colors.textPrimary}
              className="mb-0 bodyTextRegular"
            >
              {this.state.displayValue ? this.state.displayValue : "-"}
            </StyledText>
          </div>
        )}
      </>
    );
  }
}

export default InlineEdit;
